/* Small filter-bar helpers shared between AOPBudget.js and AOPBudgetFilterBar.js. */
import { FILTERS_CONFIG, isFilterActive } from "../GlobalFilterPanel";

export function filtersForKeys(keys) {
  if (!keys?.length) return FILTERS_CONFIG;
  const byKey = Object.fromEntries(FILTERS_CONFIG.map((f) => [f.key, f]));
  return keys.map((k) => byKey[k]).filter(Boolean);
}

export function isOnlyDefaultYear(filterValues, vKeys) {
  const keys = vKeys
    ? vKeys.filter((k) => k !== "year")
    : FILTERS_CONFIG.filter((f) => f.key !== "year").map((f) => f.key);
  return (
    !keys.some((k) => {
      const f = FILTERS_CONFIG.find((fc) => fc.key === k);
      return f && isFilterActive(f, filterValues[k]);
    }) && String(filterValues.year) === String(new Date().getFullYear())
  );
}
